import { useState, useEffect } from "react";
import { InputLabel, Input, ErrorMessage } from "app/components/atoms/form";

function InputMolecule({
  label,
  type,
  name,
  placeholder,
  onChange,
  onBlur,
  value,
  errorMessage,
  hideLabel = false,
  withPrefix = false,
  prefix = "",
}) {
  const [localValue, setLocalValue] = useState(value);
  const localOnChange = (event) => {
    setLocalValue(event.target.value);
    onChange(event);
  };

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value);
    }
  }, [value]);

  return (
    <div className="">
      {!hideLabel && <InputLabel>{label}</InputLabel>}
      <Input
        type={type}
        name={name}
        placeholder={placeholder}
        onChange={localOnChange}
        onBlur={onBlur}
        value={localValue}
        withPrefix={withPrefix}
        prefix={prefix}
      />
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </div>
  );
}

export default InputMolecule;
